import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {RequestMethod} from "@angular/http";
import {RequestConfig, RestResponse} from "../shared/rest/rest.request";
import {Categoria} from "../+admin/+configuraciones/+tickets/+categorias/categorias.service";
import {
    subCategoriaT,
    SubCategoriaTicket,
    TaskCategoria
} from "../+admin/+configuraciones/+tareas/+categorias/task.categorias.service";
import {isNullOrUndefined} from "util";
import {CustomHttp} from "../common/http/custom.http";
import {PageImpl} from "../common/http/PageImpl";
import {TaskAnswerView} from "../+tareas/task.service";
import {AnswersTicketView} from "../+tickets/ticket.service";
import { es_ES, NzI18nService } from 'ng-zorro-antd';

@Injectable()
export class FormatosService {
    private CREATE_CODE = new RequestConfig("FTS", "application/json", true, RequestMethod.Post, "/formats");
    private EDIT_CODE = new RequestConfig("FTS", "application/json", true, RequestMethod.Put, "/formats/{formatId}");
    private DELETE_CODE = new RequestConfig("FTS", "application/json", true, RequestMethod.Delete, "/formats/{formatId}");
    private GET_CODE = new RequestConfig("FTS", "application/json", true, RequestMethod.Get, "/formats/{formatId}");
    private DEACTIVATE = new RequestConfig("FTS", "application/json", true, RequestMethod.Put, "/formats/status/{formatId}");
    private GET_ALL = new RequestConfig("FTS", "application/json", true, RequestMethod.Get, "/formats/all/{formatId}/status");
    private GET_PAGE = new RequestConfig("FTS", "application/json", true, RequestMethod.Get, "/formats");
    private BY_CATEGORY = new RequestConfig("FTS", "application/json", true, RequestMethod.Get, "/formats/category");



    public formatCategories: Array<any> = [
        {
            name: "Ticket",
            value: "Ticket"
        },
        {
            name: "Task",
            value: "Task"
        }
    ];

    constructor(private http: CustomHttp,
                private i18n: NzI18nService) {
        this.i18n.setLocale(es_ES);
    }
    /**
     * Envia una petición a WS para guardar formato
     */
    saveFormat(formato: Formato | FormatoTicket | FormatoTask) {
        return this.http.sendRequest(this.CREATE_CODE, formato)
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envia petición a WS para obtener detalles de un formato
     */
    getFormat(idFormat: number): Observable<Formato> {
        return this.http.sendRequest(this.GET_CODE, {}, idFormat)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envia petición a WS para obtener todos los formatos
     */
    getAllFormats(active?: boolean): Observable<Array<Formato>> {
        return this.http.sendRequest(this.GET_ALL)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envía petición a WS para editar datos de formato
     */
    updateFormat(formato: Formato) {
        return this.http.sendRequest(this.EDIT_CODE, formato, formato.idFormat)
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envia petición al servidor para eliminar datos de formato
     */
    deleteFormat(idFormat: number) {
        return this.http.sendRequest(this.DELETE_CODE, {}, idFormat)
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envia petición al servidor para desactivar el formato
     */
    deactivateFormat(idFormat: number) {
        return this.http.sendRequest(this.DEACTIVATE, {}, idFormat)
            //.catch(error => this.http.handleError(error));
            .catch(this.http.handleError);
    }

    /**
     * Obtener formatos por categoría
     */
    // findByTicketOrTaskCategory(ticketCategoryId?: number, ticketSubCategoryId?: number, taskCategoryId?: number, taskSubCategoryId?: number): Observable<Array<Formato>> {
    //     let body: any;
    //     if (!isNullOrUndefined(ticketCategoryId)) {
    //         body = {idTicketCategory: ticketCategoryId};
    //     } else if (!isNullOrUndefined(taskCategoryId)) {
    //         body = {idTaskCategory: taskCategoryId};
    //
    //     }
    //     return this.http.sendRequest(this.BY_CATEGORY, body)
    //         .map(res => res.json())
    //         .catch(error => this.http.handleError(error));
    // }


    findByTicketOrTaskCategory(ticketCategoryId?: number, ticketSubCategoryId?: number, taskCategoryId?: number, taskSubCategoryId?: number): Observable<Array<Formato>> {
        let body: any;
        console.log(ticketCategoryId, ticketSubCategoryId, taskCategoryId, taskSubCategoryId);
        if(taskSubCategoryId == 0){
            taskSubCategoryId = null;
        }
        if(ticketSubCategoryId == 0){
            ticketSubCategoryId = null;
        }
        
         if (!isNullOrUndefined(ticketCategoryId)) {
            body = {idTicketCategory: ticketCategoryId,idTicketSubCategory: ticketSubCategoryId};
            // console.log('entro a la primera opcion');
        }else if (!isNullOrUndefined(taskCategoryId)) {
                 body = {idTaskCategory: taskCategoryId,idTaskSubCategory: taskSubCategoryId};
             }
        return this.http.sendRequest(this.BY_CATEGORY, body)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }
    getPage(options: any): Observable<PageImpl<Formato>> {
        return this.http.sendRequest(this.GET_PAGE, options)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }
}

@Injectable()
export class Formato {
    public active: boolean = true;
    public categoryName: string;
    public formatType: string;
    public idFormat: number;
    public jsonFormat: any;
    public taskCategoryView: TaskCategoria = new TaskCategoria();
    public taskSubCategoryView: subCategoriaT = new subCategoriaT();
    public ticketCategoryView: Categoria = new Categoria();
    public subCategoryView: SubCategoriaTicket = new SubCategoriaTicket();
    public title: string;
    public version: number;
    public obligatorio: boolean = true;
}

export class FormatoTicket {
    public active: boolean = true;
    public categoryName: string;
    public formatType: string;
    public idFormat: number;
    public jsonFormat: any;
    public ticketCategoryView: Categoria = new Categoria();
    public subCategoryView: SubCategoriaTicket = new SubCategoriaTicket();
    public title: string;
    public version: number;
    public obligatorio: boolean = true;
}

export class FormatoTask {
    public active: boolean = true;
    public categoryName: string;
    public formatType: string;
    public idFormat: number;
    public jsonFormat: any;
    public taskCategoryView: TaskCategoria = new TaskCategoria();
    public taskSubCategoryView: subCategoriaT = new subCategoriaT();
    public title: string;
    public version: number;
    public obligatorio: boolean = true;
}

export class Answers {
    username: string;
    taskView: TaskAnswerView;
    ticketView: AnswersTicketView;
    jsonAnswer: any;
    formatView: FormatView = new FormatView();
}
export class FormatView {
    title: string;
}



